/**
 * This file is generated from scripts/genIconComponents.ts. Any
 * changes should be made in that file.
 */
import { color as colorFn } from "@smartsheet/design-tokens-react";
import React, { CSSProperties, forwardRef, Ref } from "react";
import { GeneratedIconProps } from "../../components/icon/GeneratedIconProps";
import { Icon } from "../../components/icon/Icon";
import { getUrsaIconColorVarName } from "../../components/icon/getUrsaIconColorVarName";
import WarningFilledIcon16 from "./WarningFilledIcon16";
import WarningFilledIcon20 from "./WarningFilledIcon20";
import WarningFilledIcon24 from "./WarningFilledIcon24";

const getSizeMap = (viewBox?: string, width?: string | number, height?: string | number) => {
    return {
        16: viewBox ? (
            <WarningFilledIcon16 viewBox={viewBox} width={width ? width : 16} height={height ? height : 16} />
        ) : (
            <WarningFilledIcon16 width={width ? width : 16} height={height ? height : 16} />
        ),
        20: viewBox ? (
            <WarningFilledIcon20 viewBox={viewBox} width={width ? width : 20} height={height ? height : 20} />
        ) : (
            <WarningFilledIcon20 width={width ? width : 20} height={height ? height : 20} />
        ),
        24: viewBox ? (
            <WarningFilledIcon24 viewBox={viewBox} width={width ? width : 24} height={height ? height : 24} />
        ) : (
            <WarningFilledIcon24 width={width ? width : 24} height={height ? height : 24} />
        ),
    };
};

export interface WarningFilledIconProps extends GeneratedIconProps {
    /**
     * The size to render the icon at.
     */
    size: 16 | 20 | 24;

    /**
     * The fill color for the exclamation point.
     */
    innerShapeColor?: string;
}

export const WarningFilledIcon = forwardRef(
    (
        {
            // This is the default icon color.
            color = `var(${getUrsaIconColorVarName()}, ${colorFn("color--icons--neutral--strongest")})`,
            size,
            viewBox,
            width,
            height,
            style,
            innerShapeColor,
            ...rest
        }: WarningFilledIconProps,
        ref: Ref<HTMLElement>
    ) => {
        return (
            <Icon
                color={color}
                ref={ref}
                size={size}
                width={width}
                height={height}
                {...rest}
                style={
                    {
                        ...style,
                        "--sds--ursa-icons--inner-shape-color": innerShapeColor,
                    } as CSSProperties
                }
            >
                {getSizeMap(viewBox, width, height)[size]}
            </Icon>
        );
    }
);
WarningFilledIcon.displayName = "WarningFilledIcon";
